import React, { FC } from 'react';
import styled from '@emotion/styled';
import { Box } from '~Styles';
import Icon from '~ComponentsImproved/Icon';
import MinusIcon from '~Assets/icons/remove.svg';
import AddIcon from '~Assets/icons/add.svg';

const PlusIconWrapper = styled(Box)<{ size: 'small' | 'medium' }>`
  border-radius: 100%;
  background-color: var(--colorBlueGray1100);
  padding: ${(props) => (props.size === 'small' ? 'none' : '8px')};
`;

interface Props {
  amount: number;
  /** Overrides the icon displayed regardless of the amount, can be good instead of displaying nothing when it's 0 */
  icon?: 'add' | 'remove';
  size?: 'small' | 'medium';
}

const AddRemoveIcon: FC<Props> = ({ amount, icon, size = 'medium' }) => {
  return (
    <PlusIconWrapper size={size}>
      <Icon
        src={icon ? (icon === 'add' ? AddIcon : MinusIcon) : amount > 0 ? AddIcon : MinusIcon}
        width={size === 'small' ? '16px' : '24px'}
        height={size === 'small' ? '16px' : '24px'}
        color={
          icon === 'add'
            ? 'var(--colorStatusGreen)'
            : icon === 'remove'
            ? 'var(--colorUIRed)'
            : amount === 0
            ? 'var(--colorBlueGray1100)'
            : amount > 0
            ? 'var(--colorStatusGreen)'
            : 'var(--colorUIRed)'
        }
      />
    </PlusIconWrapper>
  );
};

export default AddRemoveIcon;
